"use client";

import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";

export default function SubmitButton({
  isPending = false,
  text = "Save",
  variant,
  size = "default",
  disabled = false,
  className,
}: {
  isPending?: boolean;
  text?: string;
  size?: "default" | "lg" | "sm";
  variant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link"
    | null
    | undefined;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <Button
      type="submit"
      disabled={isPending || disabled}
      variant={variant}
      size={size}
      className={className}
    >
      {isPending && <Loader2 className="animate-spin mr-2" />}
      <span className="capitalize">{text}</span>
    </Button>
  );
}
